"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValueProcessInfo = exports.serverDefaultValueProcessInfo = exports.customDefaultValueProcessInfo = exports.defaultValueProcessSync = exports.defaultValueProcess = exports.serverDefaultValueProcessSync = exports.serverDefaultValueProcess = exports.customDefaultValueProcessSync = exports.customDefaultValueProcess = exports.hasDefaultValue = exports.hasServerDefaultValue = exports.hasCustomDefaultValue = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
const formUtil_1 = require("../../utils/formUtil");
const shouldSkipDefaultValue = (component, config) => {
    // do not calculate default value for number components on the server side
    // as we cannot determine with certainty if value is removed intentionally
    return (config === null || config === void 0 ? void 0 : config.server) && (0, formUtil_1.getModelType)(component) === 'number';
};
const hasCustomDefaultValue = (context) => {
    const { component, config } = context;
    if (!component.customDefaultValue || shouldSkipDefaultValue(component, config)) {
        return false;
    }
    return true;
};
exports.hasCustomDefaultValue = hasCustomDefaultValue;
const hasServerDefaultValue = (context) => {
    const { component, config } = context;
    if (!component.hasOwnProperty('defaultValue') || shouldSkipDefaultValue(component, config)) {
        return false;
    }
    return true;
};
exports.hasServerDefaultValue = hasServerDefaultValue;
const hasDefaultValue = (context) => {
    return (0, exports.hasCustomDefaultValue)(context) || (0, exports.hasServerDefaultValue)(context);
};
exports.hasDefaultValue = hasDefaultValue;
const customDefaultValueProcess = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.customDefaultValueProcessSync)(context);
});
exports.customDefaultValueProcess = customDefaultValueProcess;
function setDefaultValue(context, defaultValue) {
    var _a;
    const { component, data, scope, path } = context;
    if (defaultValue === null || defaultValue === undefined) {
        return;
    }
    if (!scope.defaultValues)
        scope.defaultValues = [];
    scope.defaultValues.push({
        path,
        value: defaultValue,
    });
    (0, lodash_1.set)(data, path, defaultValue);
    // If this component is not already included in the filter and is not a number, then include it from the default.
    if (!scope.filter)
        scope.filter = {};
    if (!((_a = scope.clearHidden) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(path)) && (0, formUtil_1.getModelType)(component) !== 'number') {
        scope.filter[path] = true;
    }
}
const customDefaultValueProcessSync = (context) => {
    const { component, row, scope } = context;
    if (!(0, exports.hasCustomDefaultValue)(context)) {
        return;
    }
    if (!scope.defaultValues)
        scope.defaultValues = [];
    if ((0, lodash_1.has)(row, (0, formUtil_1.getComponentKey)(component))) {
        return;
    }
    let defaultValue = null;
    if (component.customDefaultValue) {
        defaultValue = (0, utils_1.evaluate)(component.customDefaultValue, context, 'value', false, (context) => (context.value = null));
        if (component.multiple && !Array.isArray(defaultValue)) {
            defaultValue = defaultValue ? [defaultValue] : [];
        }
    }
    setDefaultValue(context, defaultValue);
};
exports.customDefaultValueProcessSync = customDefaultValueProcessSync;
const serverDefaultValueProcess = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.serverDefaultValueProcessSync)(context);
});
exports.serverDefaultValueProcess = serverDefaultValueProcess;
const serverDefaultValueProcessSync = (context) => {
    const { component, row, scope } = context;
    if (!(0, exports.hasServerDefaultValue)(context)) {
        return;
    }
    if (!scope.defaultValues)
        scope.defaultValues = [];
    if ((0, lodash_1.has)(row, (0, formUtil_1.getComponentKey)(component))) {
        return;
    }
    let defaultValue = null;
    if (component.defaultValue) {
        defaultValue = component.defaultValue;
        if (component.multiple && !Array.isArray(defaultValue)) {
            defaultValue = defaultValue ? [defaultValue] : [];
        }
    }
    setDefaultValue(context, defaultValue);
};
exports.serverDefaultValueProcessSync = serverDefaultValueProcessSync;
const defaultValueProcess = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.defaultValueProcessSync)(context);
});
exports.defaultValueProcess = defaultValueProcess;
const defaultValueProcessSync = (context) => {
    (0, exports.customDefaultValueProcessSync)(context);
    (0, exports.serverDefaultValueProcessSync)(context);
};
exports.defaultValueProcessSync = defaultValueProcessSync;
exports.customDefaultValueProcessInfo = {
    name: 'customDefaultValue',
    process: exports.customDefaultValueProcess,
    processSync: exports.customDefaultValueProcessSync,
    shouldProcess: exports.hasCustomDefaultValue,
};
exports.serverDefaultValueProcessInfo = {
    name: 'serverDefaultValue',
    process: exports.serverDefaultValueProcess,
    processSync: exports.serverDefaultValueProcessSync,
    shouldProcess: exports.hasServerDefaultValue,
};
exports.defaultValueProcessInfo = {
    name: 'defaultValue',
    process: exports.defaultValueProcess,
    processSync: exports.defaultValueProcessSync,
    shouldProcess: exports.hasDefaultValue,
};
